module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-pc_4-4f372bc43a83fbec7ea0dfc085b52c17.png";